import React from "react";
import { Box, Pagination, Tab, Tabs } from "@mui/material";
import { TaskAccordian } from "../../../../Admin/Task Verification/Task Detailed/TaskAccordian";
import { useGetPendingTaskByIdQuery } from "../../../../../redux-toolkit/features/books/bookApiSlice";
import ProgressBar from "../../../../UI/ProgressBar";
import "../../../../Admin/Task Verification/Task Detailed/TaskDetailed.css";
import { EmployeeActivityEmpty } from "./EmployeeActivityEmpty";
import "./EmployeeActivityPage.css";

const sectionTabSx = {
  textTransform: "capitalize",
  fontWeight: "500",
  fontSize: "15px",
};

const PAGE_SIZE = 5;

export const EmployeeActivityTasks = ({ employeeId, onSummaryChange }) => {
  const [openSection, setOpenSection] = React.useState("PENDING");
  const [sectionPages, setSectionPages] = React.useState({
    PENDING: 1,
    APPROVED: 1,
    REJECTED: 1,
  });

  const pendingTasksQuery = useGetPendingTaskByIdQuery(
    {
      _id: employeeId,
      status: "PENDING",
      page: sectionPages.PENDING,
      limit: PAGE_SIZE,
    },
    { refetchOnMountOrArgChange: true, skip: !employeeId }
  );
  const approvedTasksQuery = useGetPendingTaskByIdQuery(
    {
      _id: employeeId,
      status: "APPROVED",
      page: sectionPages.APPROVED,
      limit: PAGE_SIZE,
    },
    { refetchOnMountOrArgChange: true, skip: !employeeId }
  );
  const rejectedTasksQuery = useGetPendingTaskByIdQuery(
    {
      _id: employeeId,
      status: "REJECTED",
      page: sectionPages.REJECTED,
      limit: PAGE_SIZE,
    },
    { refetchOnMountOrArgChange: true, skip: !employeeId }
  );

  const pendingData = pendingTasksQuery.data?.data || {};
  const approvedData = approvedTasksQuery.data?.data || {};
  const rejectedData = rejectedTasksQuery.data?.data || {};

  React.useEffect(() => {
    const summaryCandidates = [
      pendingTasksQuery.data?.data,
      approvedTasksQuery.data?.data,
      rejectedTasksQuery.data?.data,
    ];
    const summary = summaryCandidates.find(
      (sectionData) => Object.keys(sectionData || {}).length
    );
    if (summary?.user) {
      onSummaryChange?.(summary.user);
    }
  }, [
    pendingTasksQuery.data,
    approvedTasksQuery.data,
    rejectedTasksQuery.data,
    onSummaryChange,
  ]);

  const isLoading =
    pendingTasksQuery.isLoading ||
    approvedTasksQuery.isLoading ||
    rejectedTasksQuery.isLoading;
  const isFetching =
    pendingTasksQuery.isFetching ||
    approvedTasksQuery.isFetching ||
    rejectedTasksQuery.isFetching;

  const groupedTasks = {
    PENDING: pendingData?.tasks || [],
    APPROVED: approvedData?.tasks || [],
    REJECTED: rejectedData?.tasks || [],
  };
  const groupedPagination = {
    PENDING: pendingData?.tasksPagination || { totalPages: 1, totalResults: 0 },
    APPROVED: approvedData?.tasksPagination || {
      totalPages: 1,
      totalResults: 0,
    },
    REJECTED: rejectedData?.tasksPagination || {
      totalPages: 1,
      totalResults: 0,
    },
  };

  const sectionConfig = [
    {
      key: "PENDING",
      label: "Pending",
      count: groupedPagination.PENDING.totalResults || 0,
    },
    {
      key: "APPROVED",
      label: "Approved",
      count: groupedPagination.APPROVED.totalResults || 0,
    },
    {
      key: "REJECTED",
      label: "Rejected",
      count: groupedPagination.REJECTED.totalResults || 0,
    },
  ];

  const activeTasks = groupedTasks[openSection] || [];
  const activePage = sectionPages[openSection] || 1;
  const activePageCount = Math.max(
    1,
    groupedPagination[openSection]?.totalPages || 1
  );
  const activeTabIndex = Math.max(
    0,
    sectionConfig.findIndex((section) => section.key === openSection)
  );

  return (
    <div className="employeeActivityPage__section">
      <Box className="employeeActivityPage__statusTabs" sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTabIndex}
            onChange={(_event, newValue) =>
              setOpenSection(sectionConfig[newValue]?.key || "PENDING")
            }
            aria-label="employee task status tabs"
          >
            {sectionConfig.map((section) => (
              <Tab
                key={section.key}
                label={`${section.label} (${section.count})`}
                sx={sectionTabSx}
              />
            ))}
          </Tabs>
        </Box>
      </Box>

      {isLoading || isFetching ? (
        <div className="employeeActivityPage__loader">
          <ProgressBar />
        </div>
      ) : (
        <div className="employeeActivityPage__list">
          {activeTasks.length ? (
            <div className="taskdetSection__content">
              {activeTasks.map((taskItem) => (
                <TaskAccordian
                  key={taskItem?._id}
                  taskData={taskItem}
                  readOnly
                />
              ))}
            </div>
          ) : (
            <EmployeeActivityEmpty
              title={`No ${
                openSection === "PENDING"
                  ? "Pending"
                  : openSection === "APPROVED"
                    ? "Approved"
                    : "Rejected"
              } Tasks Found!`}
            />
          )}
        </div>
      )}

      <div className="employeeActivityPage__pagination">
        <Pagination
          count={activePageCount}
          shape="rounded"
          page={activePage}
          onChange={(_, newPage) =>
            setSectionPages((prev) => ({
              ...prev,
              [openSection]: newPage,
            }))
          }
        />
      </div>
    </div>
  );
};
